import React from 'react';
import { KYCFieldRow } from './KYCFieldRow';
import { KYCField } from './PersonalInfoTab';
interface BusinessInfoTabProps {
  fields: KYCField[];
  onFieldChange: (id: string, updates: Partial<KYCField>) => void;
  onSelectAll: (selected: boolean) => void;
}
// Define field metadata with Data Type, Regex, and Explanation
const fieldMetadata: Record<string, {
  fieldType: KYCField['fieldType'];
  regex?: string;
  explanation?: string;
  dropdownOptions?: string[];
}> = {
  business_name: {
    fieldType: 'text',
    regex: '^[A-Za-z0-9\\s,.-]+$',
    explanation: 'Matches alphanumeric characters, spaces, commas, periods, and hyphens, suitable for business names.'
  },
  business_type: {
    fieldType: 'dropdown',
    regex: '^[A-Za-z\\s]+$',
    explanation: 'Matches alphabetic characters and spaces (e.g., Retail, Service, etc.).',
    dropdownOptions: ['Retail', 'Service', 'Manufacturing', 'Trading', 'Other']
  },
  business_tenure: {
    fieldType: 'number',
    regex: '^\\d+$',
    explanation: 'Matches numeric values only, suitable for business tenure in years or months.'
  },
  business_address: {
    fieldType: 'text',
    regex: '^[A-Za-z0-9\\s,.-]+$',
    explanation: 'Allows letters, numbers, spaces, commas, periods, and hyphens for the business address format.'
  },
  business_location: {
    fieldType: 'text',
    regex: '^[A-Za-z0-9\\s,.-]+$',
    explanation: 'Allows letters, numbers, spaces, commas, periods, and hyphens for the business address format.'
  },
  business_ownership_type: {
    fieldType: 'dropdown',
    regex: '^[A-Za-z\\s]+$',
    explanation: 'Matches alphabetic characters and spaces, allowing values like Sole Proprietorship, Partnership, etc.',
    dropdownOptions: ['Sole Proprietorship', 'Partnership', 'Private Limited', 'Public Limited']
  },
  ntn: {
    fieldType: 'text',
    regex: '^[A-Za-z0-9]+$',
    explanation: 'Matches alphanumeric characters for NTN format.'
  }
};
export function BusinessInfoTab({
  fields,
  onFieldChange,
  onSelectAll
}: BusinessInfoTabProps) {
  const allSelected = fields.length > 0 && fields.every(f => f.selected);
  return <div className="space-y-6 py-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-362">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-363">
        <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex items-center justify-between" data-id="element-364">
          <div className="flex items-center" data-id="element-365">
            <input type="checkbox" checked={allSelected} onChange={e => onSelectAll(e.target.checked)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer" data-id="element-366" />
            <span className="ml-4 text-sm font-semibold text-gray-700" data-id="element-367">
              Business Information
            </span>
          </div>
          <div className="flex space-x-12 pr-6" data-id="element-368">
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider w-24 text-center" data-id="element-369">
              Configuration
            </span>
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-370">
          {fields.map(field => {
          const metadata = fieldMetadata[field.id] || {
            fieldType: 'text'
          };
          return <KYCFieldRow key={field.id} label={field.label} isSelected={field.selected} isMandatory={field.mandatory} isOptional={field.optional} fieldType={metadata.fieldType} regex={metadata.regex} explanation={metadata.explanation} dropdownOptions={metadata.dropdownOptions} onToggleSelect={checked => onFieldChange(field.id, {
            selected: checked
          })} onToggleMandatory={checked => onFieldChange(field.id, {
            mandatory: checked,
            optional: checked ? false : field.optional
          })} onToggleOptional={checked => onFieldChange(field.id, {
            optional: checked,
            mandatory: checked ? false : field.mandatory
          })} data-id="element-371" />;
        })}
        </div>
      </div>
    </div>;
}